module.exports = __webpack_public_path__ + "img/1.af13dee5.jpg";